import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './year-group-label.scss';

const YearGroupLabel = ({ yearGroup, children }) => {
    yearGroup = yearGroup || 0;
    const yearGroupStyle = `year-${yearGroup}`;
    return (
        <div className={`${css['year-group-label']} year-group-badge ${yearGroupStyle}`}>
            {children}
        </div>
    );
};

YearGroupLabel.propTypes = {
    yearGroup: PropTypes.number,
    children: PropTypes.any
};

export default styleable(css)(YearGroupLabel);



// WEBPACK FOOTER //
// ./components/year-group-label/year-group-label.js